"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionTreeElement = void 0;
var mobx_react_1 = require("mobx-react");
var utils_1 = require("./utils");
var React = require("react");
var typestyle_1 = require("typestyle");
var tableRowElement_1 = require("./tableRowElement");
var tableRowElementCheckbox_1 = require("./tableRowElementCheckbox");
var ActionTreeElement = (function (_super) {
    __extends(ActionTreeElement, _super);
    function ActionTreeElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionTreeElement.prototype.render = function () {
        var _this = this;
        var action_element = this.props.action;
        var action = action_element.action;
        var htmlID = (0, utils_1.getActionId)(action_element);
        var label_props = {
            project_title: action.project_title,
            number: "".concat(gettext('Action'), " #").concat(action.action_number),
            title: action.description,
            owner: action.assigned_to,
            status_display: action.status_display,
            deadline: action.deadline,
            elementType: tableRowElement_1.ElementTypes.action,
        };
        var baseClass = "TreeElement";
        var colorClass = (action.is_assigned_to === false ? "table-info" : "table-primary");
        var hoverClass = baseClass + (this.props.onClick ? "--hoverable" : "--not-hoverable");
        var classNames = (0, typestyle_1.classes)(baseClass, hoverClass, "TreeElement--NoBorder");
        return (React.createElement("tr", { className: classNames, onClick: function (event) {
                _this.props.onClick && _this.props.onClick(action_element);
            } },
            React.createElement(tableRowElementCheckbox_1.TableRowElementCheckbox, { id: htmlID, name: "actions", value: action.id.toString(), showCheckbox: this.props.showCheckbox, disabled: action.is_assigned_to === false, label_props: label_props, inputChangeHandler: this.props.inputChangeHandler, isChecked: this.props.isChecked, colorClass: colorClass }),
            this.props.addAddActionPlaceholder && (React.createElement("td", { className: colorClass }, "\u00A0"))));
    };
    ActionTreeElement = __decorate([
        mobx_react_1.observer
    ], ActionTreeElement);
    return ActionTreeElement;
}(React.Component));
exports.ActionTreeElement = ActionTreeElement;
